'use client';

import type React from 'react';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const LoaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 40vh;
  gap: 16px;
  color: rgba(255, 255, 255, 0.7);
  font-variant-caps: all-petite-caps;
  letter-spacing: 2px;
`;

const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 3px solid rgba(255, 0, 255, 0.2);
  border-top-color: #0f0;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

/**
 * Animated circular loading spinner.
 */
export const Loading: React.FC = () => {
  return (
    <LoaderWrapper role="status" aria-label="Loading content">
      <Spinner />
      <p>Loading releases...</p>
    </LoaderWrapper>
  );
};

export default Loading;
